import styled from "styled-components"

export const ActionButtonsWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 24px;
	.firstSection {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-direction: column;
		width: 100%;
		gap: 16px;
		.inputName {
			width: 100px;
			input {
				text-align: center;
			}
		}
		> div:not(.inputName) {
			width: 100%;
		}
	}
`
